import { render, staticRenderFns } from "./PendingLoanApprovals.vue?vue&type=template&id=a0d01a7a"
import script from "./PendingLoanApprovals.vue?vue&type=script&lang=js"
export * from "./PendingLoanApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports